import * as Yup from 'yup'
import { COURIER } from 'domains/seller-inbound/constants/seller-inbound-pickup-constants'
import TimeUtil from 'utils/time-util'

const SellerInboundSchedulePickupSchema = Yup.object().shape({
  scheduled_at : Yup.date().min(TimeUtil.yesterday(), 'Must today or future date').required('Required'),
  courier      : Yup.string().oneOf(
    Object.values(COURIER),
    `Harus satu dari ${Object.values(COURIER).join(', ')}`
  ).required('Required')
})

export default SellerInboundSchedulePickupSchema